import type { ReactNode } from "react";

import { classNames } from "@alpacahq/ui/old";

import { getPrettyCash } from "~/v2/utils/formatting";

export type SidebarAccountItemProperties = {
  id: string;
  title: string;
  subTitle: string;
  collapsedSubTitle: string;
  percentage?: number;
  equity?: string;
  last_equity?: string;
  hideAccountMetrics?: boolean;
};

type SidebarAccountItemProps = SidebarAccountItemProperties & {
  onClick?: () => void;
  active?: boolean;
};

const SidebarAccountItem = ({
  title,
  subTitle,
  equity,
  percentage,
  onClick,
  active,
  hideAccountMetrics,
}: SidebarAccountItemProps) => {
  return (
    <button
      className={classNames(
        `flex w-full flex-col items-start justify-between gap-[2.5px] rounded border border-cool-gray-200 p-3 transition-all`,
        !!onClick && "hover:border-yellow-600 hover:bg-yellow-100",
        active && "border-yellow-500 bg-yellow-50",
      )}
      onClick={onClick}
      type="button"
    >
      <div className="flex w-full items-center justify-between gap-1">
        <div className="truncate whitespace-nowrap font-medium text-gray-900 text-sm">
          {title}
        </div>
        {!hideAccountMetrics && (
          <div className="font-mono text-gray-900 text-sm">
            {getPrettyCash(equity, { minimumFractionDigits: 2 })}
          </div>
        )}
      </div>
      <div className="flex w-full items-center justify-between gap-1">
        <div className="truncate whitespace-nowrap text-gray-600 text-xs">
          {subTitle}
        </div>
        {!hideAccountMetrics && (
          <div
            className={classNames(
              "font-medium font-mono text-gray-600 text-xs",
              typeof percentage === "number" &&
                percentage >= 0 &&
                "text-green-600",
              typeof percentage === "number" &&
                percentage < 0 &&
                "text-red-500",
            )}
          >
            {percentage?.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
            %
          </div>
        )}
      </div>
    </button>
  );
};

type SidebarAccountButtonProps = {
  icon: ReactNode;
  label: string;
  onClick?: () => void;
};

export const SidebarAccountButton = ({
  icon,
  label,
  onClick,
}: SidebarAccountButtonProps) => (
  <button
    className="flex items-center justify-center gap-1 rounded border border-gray-400 bg-white px-4 py-2 text-center font-medium text-gray-800 text-sm transition-all hover:border-gray-500 hover:bg-gray-50"
    onClick={onClick}
    type="button"
  >
    {icon}
    {label}
  </button>
);

export default SidebarAccountItem;
